import "./LoaderOverlay.css";

type LoaderOverlayProps = {
  message?: string;
};

const LoaderOverlay = ({ message }: LoaderOverlayProps) => {
  return (
    <div className="loader-overlay">
      <div className="loader-container">
        <div className="loader-spinner">
          <div className="loader-ring base" />
          <div className="loader-ring spin" />
          <div className="loader-core" />
        </div>
        {message ? <div className="loader-text">{message}</div> : null}
      </div>
    </div>
  );
};

export default LoaderOverlay;
